import React, { useState, useEffect } from "react";
import { api } from "../../../api";
import { useQuery } from "react-query";
import { AssessementContext } from "../assessments/AssessmentContext";
import { defaultState } from "../assessments/components/defaultState";
import { exams as examsApi } from "../../../api/exams";
import { useTranslation } from 'react-i18next';
import Loader from "../../../components/loader/Loader";
import Pagination from "../../../components/Pagination/Pagination";
import Input from "../../../components/input/Input";
import EmptyData from "../../../components/EmptyData";
import SurveyCard from "../dashboard/components/SurveyCard";
const Reviews = ({ width }) => {

  const [assessment, setAssessment] = useState(defaultState);
  const [showRedirect, hideRedirect] = useState(false);
  const user = JSON.parse(sessionStorage.getItem('user'))
  const { t, i18n: i18nNext, } = useTranslation();
   const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(30);
  const [search, setSearch] = useState('')

  const { isLoading: reviewsLoading, data: reviews } = useQuery(
    ["reviews", currentPage, perPage, search],
    async () => {
      const data = await examsApi.getReviews({
        type: null, id: user?.user?.user_id, currentPage , perPage, search
      });
      return data;
    },  
    {
      select: (data) => data,
      refetchOnWindowFocus: false,
    }
  );  

  useEffect(() => {
    hideRedirect(true);
  }, []);

  return (
    <React.Fragment>
      <AssessementContext.Provider value={{ assessment, setAssessment }}>
        {(
          <>
            {/*( showRedirect && mockAssessment?.length) ? 
               <Redirect handleRedirect={hideRedirect} /> : null 
           */}
            <div
              className="mt-1 gap-4"
              style={{
                display: "flex",
                width: "100%",
                // gridTemplateColumns: width > 768 ? "4fr 1.5fr" : "1fr",
              //  border: "1px solid #ccc",
              }}
            >
              <div className="w-full md:pt-0">
                <section>
                     <div className="md:flex bg-darkBlue items-center justify-between mb-3">
                      <h5 className="max-[500px]:mb-3 text-white py-5 px-3 rounded-xl text-xl font-semibold">
                         My Reviews
                      </h5>
                      <div className="w-[300px] mr-3 text-slate-950">
                          <Input 
                            type='search'
                            placeholder={'Search reviews'}
                            onChange={ event => setSearch(event.target.value)}
                          />
                    </div>
                    </div>
                  {
                    reviewsLoading ? (
                      <Loader />
                    ) : 
                     !reviews?.data?.length > 0 ? (
                        <EmptyData text={'No Reviews Found'} />
                     ) :
                    <div className="mb-12 grid pt-4 mt-4 gap-5 grid-cols-1 md:grid-cols-3">
                      {
                        reviews?.data?.map((survey, index) => (
                           <SurveyCard survey={survey} key={survey?.id} />
                        ))
                      }
                  </div>
                      
                  }
                </section>
                 <Pagination
                      data={reviews?.meta}
                      perPage={perPage}
                      pageNo={currentPage}
                      setPageNo={setCurrentPage}
                      setPerPage={setPerPage}
                  />
              </div>
            </div>
          </>
        )}
      </AssessementContext.Provider>
    </React.Fragment>
  );
};

export default Reviews;
